import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import SearchSaveNotification, {SEARCH_SAVE_NOTIFICATION_TYPES} from './search-save-notification.js'
import {formatNotAvailableFiltersText} from './utils.js'

const SearchSaveDuplicatedAlertErrorNotification = ({
  notAvailableFilters,
  onClose = () => {},
  show,
  portalContainer,
  className
}) => {
  const {i18n} = useContext(Context)

  const notificationText = notAvailableFilters.length
    ? i18n.t('ALERT_DUPLICATED_ERROR_NOTIFICATION_MESSAGE_FOR_NOT_AVAILABLE_FILTERS', {
        smart_count: notAvailableFilters.length === 1 ? 1 : 0,
        notAvailableFilters: formatNotAvailableFiltersText({
          filters: notAvailableFilters,
          i18n
        })
      })
    : i18n.t('ALERT_DUPLICATED_ERROR_NOTIFICATION_MESSAGE')

  return (
    <SearchSaveNotification
      className={className}
      portalContainer={portalContainer}
      type={SEARCH_SAVE_NOTIFICATION_TYPES.WARNING}
      show={show}
      onClose={onClose}
    >
      {notificationText}
    </SearchSaveNotification>
  )
}

SearchSaveDuplicatedAlertErrorNotification.propTypes = {
  notAvailableFilters: PropTypes.array,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  portalContainer: typeof Element !== 'undefined' ? PropTypes.instanceOf(Element) : PropTypes.object,
  className: PropTypes.string
}

export default SearchSaveDuplicatedAlertErrorNotification
